import { render, staticRenderFns } from "./oneYuan.vue?vue&type=template&id=24e0bbb2&scoped=true"
import script from "./oneYuan.vue?vue&type=script&lang=js"
export * from "./oneYuan.vue?vue&type=script&lang=js"
import style0 from "./oneYuan.vue?vue&type=style&index=0&id=24e0bbb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e0bbb2",
  null
  
)

export default component.exports